import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EFoldersActionTypes } from '../../actions';
import { getArrayOfSelected } from '../../utils/folders';
export var initialState = {
  folders: [],
  selected: {},
  initialSelectedFolderIds: [],
  savedOfferId: [],
  savedInFolders: null,
  userHasFolders: false,
  showFoldersList: false,
  showModalCreateFolder: false,
  showOnBoardingDelete: false,
  showNotification: false,
  isListLoading: false,
  canLoadMore: false
};
export var favoritesAssignWidgetReducer = function favoritesAssignWidgetReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case EFoldersActionTypes.SetFolders:
      return _objectSpread(_objectSpread({}, state), {}, {
        folders: action.payload.folders,
        canLoadMore: action.payload.canLoadMore
      });
    case EFoldersActionTypes.SetSelected:
      return _objectSpread(_objectSpread({}, state), {}, {
        selected: action.payload.selectedFolders,
        initialSelectedFolderIds: getArrayOfSelected(action.payload.selectedFolders),
        folders: state.folders.map(function (folder) {
          return _objectSpread({}, folder);
        })
      });
    case EFoldersActionTypes.SelectFolder:
      return _objectSpread(_objectSpread({}, state), {}, {
        folders: state.folders.map(function (folder) {
          return _objectSpread({}, folder);
        }),
        selected: _objectSpread(_objectSpread({}, state.selected), {}, _defineProperty({}, action.payload.folderId, true))
      });
    case EFoldersActionTypes.UnselectFolder:
      return _objectSpread(_objectSpread({}, state), {}, {
        folders: state.folders.map(function (folder) {
          return _objectSpread({}, folder);
        }),
        selected: _objectSpread(_objectSpread({}, state.selected), {}, _defineProperty({}, action.payload.folderId, false))
      });
    case EFoldersActionTypes.AddNewFolder:
      {
        var newFolders = state.folders.map(function (folder) {
          return _objectSpread({}, folder);
        });
        newFolders.unshift(action.payload.folder);
        return _objectSpread(_objectSpread({}, state), {}, {
          folders: newFolders,
          selected: _objectSpread(_objectSpread({}, state.selected), {}, _defineProperty({}, action.payload.folder.id, true))
        });
      }
    case EFoldersActionTypes.AddSavedOffer:
      {
        var offerIds = action.payload.offerIds;
        return _objectSpread(_objectSpread({}, state), {}, {
          savedOfferId: Array.isArray(offerIds) ? offerIds : [offerIds],
          savedInFolders: action.payload.savedInFolders,
          userHasFolders: action.payload.userHasFolders,
          folders: state.folders.map(function (folder) {
            return _objectSpread({}, folder);
          }),
          showNotification: true
        });
      }
    case EFoldersActionTypes.HideNotification:
      return _objectSpread(_objectSpread({}, state), {}, {
        folders: state.folders.map(function (folder) {
          return _objectSpread({}, folder);
        }),
        savedInFolders: state.savedInFolders ? _toConsumableArray(state.savedInFolders) : null,
        showNotification: false
      });
    case EFoldersActionTypes.ShowFavoritesFoldersList:
      return _objectSpread(_objectSpread({}, state), {}, {
        folders: state.folders.map(function (folder) {
          return _objectSpread({}, folder);
        }),
        savedOfferId: action.payload.offerIds,
        savedInFolders: null,
        selected: {},
        showFoldersList: true,
        showNotification: false
      });
    case EFoldersActionTypes.HideFavoritesFoldersList:
      return _objectSpread(_objectSpread({}, state), {}, {
        folders: state.folders.map(function (folder) {
          return _objectSpread({}, folder);
        }),
        showFoldersList: false
      });
    case EFoldersActionTypes.ShowModalCreateFolder:
      return _objectSpread(_objectSpread({}, state), {}, {
        folders: state.folders.map(function (folder) {
          return _objectSpread({}, folder);
        }),
        savedOfferId: action.payload ? action.payload.offerIds : _toConsumableArray(state.savedOfferId),
        savedInFolders: null,
        selected: {},
        showModalCreateFolder: true,
        showNotification: false
      });
    case EFoldersActionTypes.HideModalCreateFolder:
      return _objectSpread(_objectSpread({}, state), {}, {
        folders: state.folders.map(function (folder) {
          return _objectSpread({}, folder);
        }),
        showModalCreateFolder: false
      });
    case EFoldersActionTypes.SetListLoading:
      return _objectSpread(_objectSpread({}, state), {}, {
        folders: state.folders.map(function (folder) {
          return _objectSpread({}, folder);
        }),
        isListLoading: action.payload.isLoading
      });
    case EFoldersActionTypes.ShowOnBoardingDelete:
      return _objectSpread(_objectSpread({}, state), {}, {
        folders: state.folders.map(function (folder) {
          return _objectSpread({}, folder);
        }),
        showOnBoardingDelete: true,
        showNotification: false
      });
    default:
      return state;
  }
};